module.exports = __webpack_public_path__ + "ce3304a6d11ecc3deaa5912df07421a2.jpg";